import React, { ReactNode } from "react";
import DatePicker from "react-datepicker2";
import { Controller } from "react-hook-form";

import styles from "../input.module.scss";
import classNames from "classnames";
import moment from "moment-jalaali";
interface DateInputProps {
  controller: any;
  name: string;
  label?: string;
  placeholder?: string;
  error?: string;
  className?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isHorizontal?: boolean;
  icon?:ReactNode;
}
export const DateInput: React.FC<DateInputProps> = ({
  controller,
  name,
  className,
  isRequired = false,
  isDisabled = false,
  label,
  placeholder,
  isHorizontal = false,
  icon
}) => {
  const inputContainerClass = classNames(
    className,
    styles.container,
    isHorizontal && styles.isHorizontal
  );
  const inputClass = classNames(
    styles.input_container,
    isDisabled && styles.disabled
  );
  return (
    <div className={inputContainerClass}>
      <div className={styles.label}>
        {isRequired && <span className="text-danger"> * </span>}
        {icon}
        {label && <span>{label}</span>}
      </div>
      <div className={inputClass}>
        {isDisabled ? (
          <>
            <Controller
              control={controller}
              name={name}
              render={({ field: { value } }) => {
                return (
                  <input
                    disabled={isDisabled}
                    value={moment(value).format("jYYYY/jM/jD")}
                    placeholder={placeholder}
                  />
                );
              }}
            />
          </>
        ) : (
          <>
            <Controller
              control={controller}
              name={name}
              render={({ field: { onChange, onBlur, value } }) => {
                return (
                  <DatePicker
                    onChange={onChange}
                    onBlur={onBlur}
                    value={moment(value)}
                    isGregorian={false}
                    timePicker={false}
                  />
                );
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};
